<template>
  <v-container
    grid-list-xs
    class="d-flex flex-column justify-center align-center register-section py-16 fill-height"
  >
    <v-card class="card" :class="!currentWave ? 'card-wrapper' : ''">
      <div v-if="currentWave">
        <v-card-title
          primary-title
          class="dark-blue white--text title font-weight-medium login-title px-10 card-border"
          >Daftar</v-card-title
        >

        <v-container grid-list-xs class="card-body pt-0">
          <v-form class="form" ref="form" @submit.prevent>
            <v-text-field
              label="Nama Lengkap"
              class="mt-10"
              v-model="name"
              :rules="[(v) => !!v || 'Mohon isi nama lengkap']"
              filled
              @keyup.enter.native="register"
            >
              <template v-slot:prepend-inner>
                <v-icon class="mx-2">mdi-account-outline</v-icon>
              </template>
            </v-text-field>

            <v-text-field
              label="Email"
              v-model="username"
              :rules="emailRules"
              filled
              @keyup.enter.native="register"
            >
              <template v-slot:prepend-inner>
                <v-icon class="mx-2">mdi-email-outline</v-icon>
              </template>
            </v-text-field>

            <v-text-field
              label="Password"
              v-model="password"
              :rules="passwordRules"
              filled
              :type="show1 ? 'text' : 'password'"
              :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
              @click:append="show1 = !show1"
              @keyup.enter.native="register"
            >
              <template v-slot:prepend-inner>
                <v-icon class="mx-2">mdi-lock-outline</v-icon>
              </template>
            </v-text-field>

            <v-text-field
              label="Konfirmasi Password"
              v-model="confirmPassword"
              filled
              :rules="confirmationPasswordRules"
              :type="show2 ? 'text' : 'password'"
              :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
              @click:append="show2 = !show2"
              @keyup.enter.native="register"
            >
              <template v-slot:prepend-inner>
                <v-icon class="mx-2">mdi-lock-outline</v-icon>
              </template>
            </v-text-field>

            <center>
              <p v-if="error" class="red--text caption">{{ error }}</p>

              <div class="d-flex justify-center my-3" style="min-height: 78px;">
                <div ref="recaptchaContainer"></div>
              </div>

              <div v-if="recaptchaFailed" class="mb-3">
                <p class="red--text caption mb-2">
                  Gagal memuat reCAPTCHA. Pastikan koneksi internet stabil atau nonaktifkan ad-blocker.
                </p>
                <v-btn small outlined color="dark-blue" @click="retryRecaptcha">
                  <v-icon small left>mdi-refresh</v-icon> Coba Muat Ulang
                </v-btn>
              </div>

              <v-btn
                color="dark-blue white--text btn-auth mt-5"
                @click="register"
                >Daftar</v-btn
              >
              <p class="pt-5 subtitle-1 font-weight-normal">
                Sudah punya akun?
                <router-link
                  to="/masuk"
                  class="text-decoration-none accentDarkBlue--text font-weight-bold"
                  >Masuk</router-link
                >
              </p>
            </center>
          </v-form>
        </v-container>
      </div>
      <div v-if="!currentWave" class="pa-5">
        <v-container grid-list-xs py-5>
          <center>
            <p>Pendaftaran akun masih ditutup</p>
          </center>
        </v-container>
      </div>
    </v-card>
  </v-container>
</template>

<script>
import axios from "axios";
import { EventBus } from "../event-bus";
import moment from "moment";

export default {
  data: () => ({
    name: "",
    handphone: "",
    username: "",
    password: "",
    confirmPassword: "",
    error: "",
    currentWave: "",
    date: "",
    show1: false,
    token: "",
    show2: false,
    sitekey: "6Ldzu6UoAAAAAE7c8kKAlGsbX49zOe3SsfTOA5pN",
    widgetId: null,
    recaptchaTimer: null,
    recaptchaFailed: false,
    emailRules: [
      (v) => !!v || "Mohon isi email",
      (v) => /.+@.+\..+/.test(v) || "Email tidak valid",
    ],

    handphoneRules: [
      (v) => !!v || "Mohon isi nomor WhatsApp Aktif",
      (v) =>
        /^[0-9]+$/.test(v) ||
        "Nomor handphone harus berupa angka dan tanpa spasi",
    ],
    usernameRules: [
      (v) => !!v || "Mohon isi username",
      (v) =>
        /^[a-z0-9_@.]+$/.test(v) ||
        "Username hanya boleh mengandung huruf kecil, angka, dan beberapa karakter seperti email",
      (v) => (v && v.length >= 6) || "Username harus lebih dari 6 karakter",
    ],
    passwordRules: [
      (v) => !!v || "Mohon isi password",
      (v) => (v && v.length >= 6) || "Password harus lebih dari 6 karakter",
    ],
  }),

  computed: {
    confirmationPasswordRules() {
      return [
        () =>
          this.password === this.confirmPassword ||
          "Konfirmasi password harus sama dengan password",
        (v) => !!v || "Mohon isi konfirmasi password",
      ];
    },
  },

  watch: {
    currentWave(newVal) {
      if (newVal) {
        this.$nextTick(() => {
          this.initRecaptcha();
        });
      }
    },
  },

  mounted() {
    this.checkWave();
    if (this.currentWave) {
      this.$nextTick(() => {
        this.initRecaptcha();
      });
    }
  },

  beforeDestroy() {
    if (this.recaptchaTimer) {
      clearInterval(this.recaptchaTimer);
      this.recaptchaTimer = null;
    }
  },

  methods: {
    initRecaptcha() {
      this.recaptchaFailed = false;
      if (this.recaptchaTimer) {
        clearInterval(this.recaptchaTimer);
        this.recaptchaTimer = null;
      }

      const checkAndRender = () => {
        if (
          typeof window !== "undefined" &&
          typeof window.grecaptcha !== "undefined" &&
          typeof window.grecaptcha.render === "function"
        ) {
          if (typeof window.grecaptcha.ready === "function") {
            window.grecaptcha.ready(() => {
              this.renderRecaptcha();
            });
          } else {
            this.renderRecaptcha();
          }
          return true;
        }
        return false;
      };

      if (checkAndRender()) return;

      if (
        typeof document !== "undefined" &&
        !document.querySelector('script[src*="google.com/recaptcha/api.js"]')
      ) {
        const script = document.createElement("script");
        script.src = "https://www.google.com/recaptcha/api.js";
        script.async = true;
        script.defer = true;
        document.head.appendChild(script);
      }

      let attempts = 0;
      const maxAttempts = 60; // 60 * 100ms = 6 detik
      this.recaptchaTimer = setInterval(() => {
        attempts++;
        if (checkAndRender()) {
          clearInterval(this.recaptchaTimer);
          this.recaptchaTimer = null;
        } else if (attempts >= maxAttempts) {
          clearInterval(this.recaptchaTimer);
          this.recaptchaTimer = null;
          this.recaptchaFailed = true;
        }
      }, 100);
    },

    renderRecaptcha() {
      if (!this.$refs.recaptchaContainer) return;

      if (this.widgetId !== null) {
        try {
          window.grecaptcha.reset(this.widgetId);
        } catch (e) {
          // ignore reset error
        }
        return;
      }

      try {
        this.widgetId = window.grecaptcha.render(this.$refs.recaptchaContainer, {
          sitekey: this.sitekey,
          callback: (token) => {
            this.token = token;
            this.error = "";
            EventBus.$emit("showSnackbar", "Recaptcha berhasil", "green");
          },
          "expired-callback": () => {
            this.token = "";
          },
          "error-callback": () => {
            this.token = "";
            this.error =
              "Terjadi kesalahan pada verifikasi reCAPTCHA. Silakan coba lagi.";
          },
        });
      } catch (err) {
        // Container already rendered or unmounted
      }
    },

    resetRecaptcha() {
      this.token = "";
      if (
        typeof window !== "undefined" &&
        typeof window.grecaptcha !== "undefined" &&
        this.widgetId !== null
      ) {
        try {
          window.grecaptcha.reset(this.widgetId);
        } catch (e) {
          // ignore reset error
        }
      }
    },

    retryRecaptcha() {
      this.recaptchaFailed = false;
      this.initRecaptcha();
    },

    checkWave() {
      moment.locale("id");

      const currentTime = moment(localStorage.getItem("date"));
      this.date = currentTime;

      const currentWave = this.$date.filter((itemDate) => {
        const range = moment().range(
          moment(itemDate.open),
          moment(itemDate.close)
        );
        return range.contains(currentTime);
      });

      if (currentWave.length > 0) this.currentWave = currentWave;
      else this.currentWave = "";
    },

    async register() {
      if (!this.$refs.form.validate()) {
        return;
      }

      if (!this.token) {
        this.error = "Mohon selesaikan verifikasi reCAPTCHA terlebih dahulu";
        return;
      }

      this.error = "";
      EventBus.$emit("startLoading");

      axios
        .post(`${this.$api}/register`, {
          "g-recaptcha-response": this.token,
          nama: this.name,
          username: this.username,
          email: this.username,
          role: 1,
          password: this.password,
        })
        .then((response) => {
          if (response.data.STATUS === "ERROR") {
            this.error =
              response.data.MESSAGE || "Pendaftaran gagal. Silakan coba lagi.";
            this.resetRecaptcha();
          } else {
            localStorage.setItem(
              "token",
              response.data.PAYLOAD.u_login_token
            );
            localStorage.setItem("id", response.data.PAYLOAD.u_id);
            localStorage.setItem(
              "username",
              response.data.PAYLOAD.u_username
            );

            EventBus.$emit("triggerCheckLoginToken");
            this.$router.push({ name: "home" });
          }
        })
        .catch((err) => {
          this.error =
            err.response && err.response.data && err.response.data.MESSAGE
              ? err.response.data.MESSAGE
              : "Terjadi kesalahan pada sistem. Silakan coba lagi nanti.";
          this.resetRecaptcha();
        })
        .finally(() => {
          EventBus.$emit("stopLoading");
        });
    },
  },
};
</script>

<style scoped>
.card {
  border-radius: 10px !important;
}

.card-border {
  border-top-left-radius: 10px !important;
  border-top-right-radius: 10px !important;
}

.btn-auth {
  width: 100% !important;
  border-radius: 10px !important;
  padding-top: 1.5rem !important;
  padding-bottom: 1.5rem !important;
  font-size: 1rem;
  letter-spacing: 0.15rem;
}
.dark-blue {
  background-color: #24305e !important;
}

.card-wrapper {
  margin: 100px 0;
  width: 70%;
}

.register-section {
  min-height: 90vh;
}

.register-title {
  font-family: "Montserrat", sans-serif !important;
}

.card-body {
  padding: 30px;
}

.form {
  width: 450px;
}

@media screen and (max-width: 600px) {
  .form {
    width: 400px;
  }
}

@media screen and (max-width: 450px) {
  .register-section {
    height: 110vh;
  }

  .card {
    width: 90%;
  }

  .form {
    width: 100%;
    margin: 0 auto;
  }
}

@media screen and (max-width: 500px) {
  .card-wrapper {
    width: 80%;
  }
}
</style>